module.exports = __webpack_public_path__ + "img/gh-36070.asm.17d49054.jpg";